export default __webpack_public_path__ + "static/media/5.0c19e634.jpg";